import { Button } from "@devhop/ui";
import { PlusIcon } from "lucide-react";

type StaffToolbarProps = {
  canManage?: boolean;
  onCreate: () => void;
};

export function StaffToolbar({ canManage, onCreate }: StaffToolbarProps) {
  return (
    <div className="mb-6 flex flex-wrap items-center justify-between gap-3">
      <div>
        <h2 className="font-bold text-2xl tracking-tight">Staff</h2>
        <p className="text-muted-foreground text-sm">
          ຈັດການລາຍຊື່ Staff ກາງ — ໃຊ້ມອບໝາຍໃນແຕ່ລະ Event
        </p>
      </div>
      {canManage ? (
        <Button onClick={onCreate}>
          <PlusIcon className="size-4" /> ເພີ່ມ Staff
        </Button>
      ) : null}
    </div>
  );
}
